import { inject, injectable } from 'tsyringe';
import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';
import { type ISupporterBuyerEditRepository } from 'application/repositorySchemas/ISupporterBuyerEditRepository';
import { type ISupporterEditBuyerProfileClient } from 'interfaceAdapter/gatewaySchemas/ISupporterEditBuyerProfileClient';

@injectable()
export class SupporterBuyerEditRepository implements ISupporterBuyerEditRepository {
    constructor(
        @inject('ISupportUserTokenRepository')
        public readonly supportUserToken: ISupportUserTokenRepository,
        @inject('ISupporterEditBuyerProfileClient')
        public readonly supporterEditBuyerProfileClient: ISupporterEditBuyerProfileClient,
    ) {}

    // TODO 型づけをサボっている
    public async editProfile(buyer: any) {
        const { data, message } = await this.supporterEditBuyerProfileClient.post({
            token: this.supportUserToken.get() || '',
            buyerId: buyer.buyer_id,
            buyer,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
